export const IMPERSONATING = 'impersonating'
export const BACK_TO_DASHBOARD_ID = 'back-to-dashboard-id'
